<template>
  <select v-model="selectedProperty" class="pd-Cart_VariantLink" name="propertySelect">
    <option :value="false">{{ selectedEmpty ? please_choose_text : reset_filter_text }}</option>
    <option v-for="property in filteredProperties" :key="property.value" :value="property">{{
      property.value
    }}</option>
  </select>
</template>

<script>
import compareProperties from "../mixins/compareProperties";

export default {
  name: "VariantPickerPropertySelect",
  mixins: [compareProperties],
  props: {
    identifier: {
      type: String,
      default: "",
    },
    properties: {
      required: true,
      type: Array,
    },
    propertyKey: {
      required: true,
      type: String,
    },
    please_choose_text: {
      required: true,
      type: String,
    },
    reset_filter_text: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      selectedProperty: false,
    };
  },
  computed: {
    selectedProperties() {
      return this.$store.getters[`variantPicker${this.identifier}/selectedProperties`];
    },
    allProductVariants() {
      return this.$store.getters[`variantPicker${this.identifier}/allProductVariants`];
    },
    selectedEmpty() {
      return this.selectedProperties.length === 0;
    },
    filteredProperties() {
      if (this.selectedEmpty) return this.properties;
      return this.properties.filter(property => this.hasSelectedSiblings(property));
    },
  },
  watch: {
    selectedProperty(newProperty, oldProperty) {
      this.selectChangeHandler();
      if (oldProperty !== false && newProperty === false) {
        this.$store.dispatch(
          `variantPicker${this.identifier}/emptySelectedProperties`,
          this.property
        );
      }
    },
    selectedProperties() {
      if (this.selectedEmpty) {
        this.selectedProperty = false;
      }
      if (!this.selectedProperty) {
        const selected = this.selectedProperties.find(
          selectedProperty => selectedProperty.key === this.propertyKey
        );

        if (selected) {
          this.selectedProperty = selected;
        }
      }
    },
    filteredProperties() {
      const selectedContainedByFiltered = this.filteredProperties.find(filteredProperty =>
        this.compareProperties(this.selectedProperty, filteredProperty)
      );

      if (!selectedContainedByFiltered) {
        this.selectedProperty = false;
      }
    },
  },
  methods: {
    selectChangeHandler() {
      this.$store.dispatch(
        `variantPicker${this.identifier}/setSelectedProperties`,
        this.selectedProperty
      );
    },
    hasSelectedSiblings(property) {
      const hasSiblings = this.allProductVariants
        .map(variant => variant.properties)
        .filter(properties =>
          properties.some(property =>
            this.selectedProperties.some(selectedProperty =>
              this.compareProperties(property, selectedProperty)
            )
          )
        )
        .reduce((flatened, properties) => flatened.concat(properties), [])
        .some(storeProperty => this.compareProperties(storeProperty, property));

      return hasSiblings;
    },
  },
};
</script>
